module.exports = __webpack_public_path__ + "img/SZ.e9dcc40d.svg";